import { forwardRef } from 'react';
import { ChildrenProps } from '@cotera/client/app/components/utils';
import { classNames } from '@cotera/client/app/components/utils';

export const P = forwardRef<
  HTMLParagraphElement,
  ChildrenProps & { className?: string }
>(({ children, className }, ref) => {
  return (
    <p
      ref={ref}
      className={classNames('text-foreground', 'text-sm', className)}
    >
      {children}
    </p>
  );
});
